module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-list"
  }, [_c('div', {
    staticClass: "breadcrumb-bar"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/buycourse'
      }
    }
  }, [_vm._v("购买课程")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("课程详情")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main-box"
  }, [_c('Card', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "panel-box"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("课包基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.showPkg,
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课包名称:"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.showPkg.name))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课包ID:"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.showPkg.id))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "级别:"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.showPkg.level))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "封面:"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.showPkg.image,
      "width": "80px",
      "height": "80px"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "周期:"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.showPkg.period) + "课程")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程类型:"
    }
  }, [_c('span', [_vm._v("体系课")])]), _vm._v(" "), _c('br')], 1)], 1)])]), _vm._v(" "), _c('Card', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "panel-box"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("已添加课")]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formCourse,
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "展示顺序："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入阿拉伯数字搜索"
    },
    model: {
      value: (_vm.formCourse.period),
      callback: function($$v) {
        _vm.$set(_vm.formCourse, "period", $$v)
      },
      expression: "formCourse.period"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入名称搜索"
    },
    model: {
      value: (_vm.formCourse.name),
      callback: function($$v) {
        _vm.$set(_vm.formCourse, "name", $$v)
      },
      expression: "formCourse.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": _vm.onQuery
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.courseData,
      "stripe": "",
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#1d90e6"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.viewAlbum(scope.row.albumId)
            }
          }
        }, [_vm._v(_vm._s(scope.row.id))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order",
      "label": "展示顺序",
      "align": "center",
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.order + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "level",
      "label": "级别",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "align": "center",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#1d90e6"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.viewAlbum(scope.row.albumId)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "image",
      "label": "图片",
      "align": "center",
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": scope.row.image,
            "min-width": "70",
            "height": scope.row.image != '' ? 70 : 20
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "count",
      "label": "内容数量",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), (_vm.$route.query.type == 'Course') ? _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "更新时间",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "btnFlex"
        }, [_c('span', {
          staticStyle: {
            "padding-right": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.updated_at))])])]
      }
    }], null, false, 3201146378)
  }) : _vm._e(), _vm._v(" "), (_vm.$route.query.type == 'Class') ? _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "解锁时间",
      "align": "center",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "btnFlex"
        }, [_c('span', {
          staticStyle: {
            "padding-right": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.date))]), _vm._v(" "), _c('stUpdated', {
          attrs: {
            "rowDta": scope.row
          },
          on: {
            "stUpdatedResult": _vm.editstUpdated
          }
        })], 1)]
      }
    }], null, false, 474393980)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "enabled",
      "label": "上下架状态",
      "align": "center",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.enabled) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("已上架")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("已下架")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-box"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.page,
      "page-sizes": [20, 50, 100],
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageTotal
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      }
    }
  })], 1)], 1)])]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "49%",
      "margin-top": "30px",
      "margin-bottom": "50px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmSubmit
    }
  }, [_vm._v("确定")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-243cbd26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/course/detailbuyCourse.vue
// module id = 666
// module chunks = 1